import { styled } from 'src/styles/stitches.config'

export const StyledImage = styled('img', {
    maxWidth: '100%',
    height: 'auto',
})
